module.exports = __webpack_public_path__ + "static/img/lres9.9078067.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lres9.png
// module id = Pk94
// module chunks = 1